import { createAction, props } from '@ngrx/store';
import { Point } from '../../../tracks/models/point';


export const getPoints = createAction(
  '[Points] Get Points',
  props<{unitIds: number[], dateFrom: string, dateTo: string}>()
);
export const clearCache = createAction(
  '[Points] Clear Cache'
);
export const selectPoint = createAction(
  '[Points] Select Point',
  props<{point: Point}>()
);
export const setPointsLoading = createAction(
  '[Points] Set Points Loading',
  props<{isLoading: boolean}>()
)
export const setPointsViewer = createAction(
  '[Points] SET Points Viewer',
  props<{point: Point[]}>()
)

export type PointsActionsUnion = ReturnType<
  typeof getPoints |
  typeof clearCache |
  typeof selectPoint |
  typeof setPointsLoading |
  typeof setPointsViewer
>;
